// extracted by mini-css-extract-plugin
module.exports = {"root":"az_CHc","absolute":"az_DHc","inset":"az_EHc","light":"az_FHc","middle":"az_GHc","vertical":"az_HHc","flexItem":"az_IHc"};